var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4SafetyShoesMandatory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.27 47.33a19.26 19.26 0 01-6.55-5.18l-7.71-9L76 0h-6L0 70v5.85l16.53-16.4.88 3.55H27V49l4.2-4.18C36.42 50.54 39.8 63 49.86 63H70v-6c0-2.43-7.85-7-12.73-9.67zM23 59h-2.42l-.71-2.87L23 53v6zM11.19 38.08L11 20.56A5.579 5.579 0 0116.6 15h10.95l10.21 12-15.12 15h-6.25l1.23 5-3.37 3.35-3.06-12.27z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Safety_shoes_mandatory.7aea5b4b.svg";
export { SvgE4SafetyShoesMandatory as ReactComponent };